module.exports = __webpack_public_path__ + "static/media/29ADMSPC37.45d83f1a.jpg";